import React from 'react';
import { Container, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import MissionForm from '../components/MissionForm';

const CreateMissionPage = () => {
  const navigate = useNavigate();
  
  const handleClose = () => {
    navigate('/mission-orders');
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Créer une nouvelle mission
      </Typography>
      
      <MissionForm open={true} onClose={handleClose} />
    </Container>
  );
};

export default CreateMissionPage;
